import {Component, OnInit} from '@angular/core';
import {QrGeneratorService} from "../../services/qr-generator/qr-generator.service";
import {UUID} from 'angular2-uuid';
import {Md5} from 'ts-md5/dist/md5';
import {QrCode} from "../../models/qr-code";
import {DatabaseService} from "../../services/database/database.service";
import {ActivatedRoute} from "@angular/router";
import {Database} from "../../models/database";
import {ArtworkService} from "../../services/artwork/artwork.service";
import {Artwork} from "../../models/artwork";
import {merge, zip} from "rxjs";

@Component({
  selector: 'app-qr-generator',
  templateUrl: './qr-generator.component.html',
  styleUrls: ['./qr-generator.component.scss']
})

export class QrGeneratorComponent implements OnInit {

  qrCodeTicket: string;
  qrCodeFree: string;
  projectId: string;
  databaseId: string;
  welcomePageIsSet: boolean = false;
  artworks: Artwork[] = [];
  invalidArtwork: Artwork;
  loaded = false;

  dbTitle: string;
  dbCode: string;

  constructor(
    private route: ActivatedRoute,
    private qrGeneratorService: QrGeneratorService,
    private databaseService: DatabaseService,
    private artworksService: ArtworkService,
  ) {
  }

  private microtime(getAsFloat = false) {
    let s;
    let now;
    let multiplier;

    if (typeof performance !== 'undefined' && performance.now) {
      now = (performance.now() + performance.timing.navigationStart) / 1000;
      multiplier = 1e6; // 1,000,000 for microseconds
    } else {
      now = (Date.now ? Date.now() : new Date().getTime()) / 1000;
      multiplier = 1e3; // 1,000
    }

    // Getting microtime as a float is easy
    if (getAsFloat) {
      return now;
    }

    // Dirty trick to only get the integer part
    s = now | 0;

    return (Math.round((now - s) * multiplier) / multiplier) + ' ' + s;
  }

  private md5(str) {
    return String(new Md5().appendStr(str).end());
  }

  checkWelcomePage(database: Database) {
    if (
      !database ||
      !database.structure.name ||
      !(database.structure.ticket != null)
    )
      return false;

    return true;
  }

  getInvalidArtwork(artworks: Artwork[]) {
    for (const art of artworks) {
      if (!art.categories.length)
        return art;
    }
    return null;
  }

  createQrTicket(database) {
    const mc = database.code;
    const tc = UUID.UUID().replace(/-/g, '').substr(0, 13) + this.microtime();
    const main = this.md5(this.md5(mc) + this.md5(tc));

    const qrCode = new QrCode({
      mc: mc,
      tc: tc,
      h: 87600,
      mn: database.structure.name,
      t: main + this.md5(main).substring(4, 10)
    });

    return JSON.stringify(qrCode.getObj());
  }

  createQrFree(database) {
    return 'http://museon.it/n/' + database.code;
  }

  ngOnInit() {
    this.route.parent.params.subscribe(
      params => {
        this.dbTitle = encodeURIComponent(this.databaseService.database.structure.name);
        this.dbCode = this.route.snapshot.queryParams.c;
        this.projectId = params['project_id'];
        this.databaseId = params['database_id'];

        merge(
          this.artworksService.getAllMyArtworks(this.projectId, this.databaseId),
          this.artworksService.onChange
        ).subscribe(_ => {

          this.artworks = [...this.artworksService.artworks];

          this.welcomePageIsSet = this.checkWelcomePage(this.databaseService.database);
          this.invalidArtwork = this.getInvalidArtwork(this.artworks);

          if (this.welcomePageIsSet) {
            this.qrGeneratorService.exportDatabases(this.projectId)
              .subscribe(_ => {
                const database = this.databaseService.database;

                this.qrCodeTicket = this.createQrTicket(database);
                this.qrCodeFree = this.createQrFree(database);
              }, console.error, () => this.loaded = true)
          } else {
            this.loaded = true;
          }
        })
      });
  }
}
